export default __webpack_public_path__ + "static/media/Savior's Totem Pole.1187edc9.jpg";